import { ChecksTabConfig } from 'helpers/useAccordionTab';
import { Option, OptionGroup } from 'components/Forms/MultiSelectField';
import {
  CartProcessingRedirect,
  CriteriaType,
  RecipientSelectionMode,
  TypeFilter,
} from 'store/shoppingCart/types';

export const CART_LOAD_ERROR = "Couldn't load this client's cart.";

export const SETTINGS_SECTION_INDEX = 0;
export const CHECKOUT_PAGE_DESIGN_SECTION_INDEX = 1;
export const DONATION_OPTIONS_SECTION_INDEX = 2;

export const SHOPPING_CART_SECTIONS = [
  'Shopping Cart Settings',
  'Checkout Page Design',
  'Donation Options',
];

export const DEFAULT_DONATION_AMOUNTS = [10, 25, 50, 100, 250];

// Mirrors the backend's DEFAULT_SHOPPING_CART_MAX_RESULTS - an unset max_results
// reports as this value anyway, so the field shows it rather than sitting empty.
export const DEFAULT_MAX_RESULTS = 10;
// Mirrors CART_MAX_RESULTS_MIN/MAX in backend/shared/constants/shopping_cart.py.
export const MIN_MAX_RESULTS = 1;
export const MAX_MAX_RESULTS = 1000;

export const SHOPPING_CART_PAGE_TYPE = 'shopping_cart';
export const SHOPPING_CART_CHECKS_TAB: ChecksTabConfig = {
  [SHOPPING_CART_PAGE_TYPE]: [
    ['criteria', 'max_results'],
    ['page_name', 'query_string'],
    ['donation_amounts'],
  ],
};

export const RECIPIENT_SELECTION_MODE_OPTIONS = [
  { value: RecipientSelectionMode.RECIPIENTS_LIST, label: 'Recipient List' },
  { value: RecipientSelectionMode.CRITERIA_MATCH, label: 'Criteria Match' },
];

// CANDIDATE_STATE covers both "Statewide" and "State Leg" from the Figma mock -
// the real API has one enum value where the mock shows two.
export const CRITERIA_OPTIONS: Option[] = [
  { value: CriteriaType.CANDIDATE_FEDERAL, label: 'Federal Candidates' },
  { value: CriteriaType.CANDIDATE_STATE, label: 'Statewide & State Legislative Candidates' },
  { value: CriteriaType.CANDIDATE_LOCAL, label: 'Local Candidates' },
  { value: CriteriaType.ORGANIZATION, label: 'Organizations' },
  { value: CriteriaType.BALLOT_MEASURE, label: 'Ballot Measures' },
];

export const TYPE_FILTER_OPTIONS: OptionGroup[] = [
  {
    label: 'Organizations',
    options: [
      { value: TypeFilter.PAC, label: 'PAC' },
      { value: TypeFilter.ORGANIZATION_501C4, label: 'Advocacy / 501(c)4' },
      { value: TypeFilter.ORGANIZATION_501C3, label: 'Charitable Nonprofit / 501(c)3' },
      { value: TypeFilter.ORGANIZATION_OTHER, label: 'Other Organizations' },
    ],
  },
  {
    label: 'Ballot measures',
    options: [{ value: TypeFilter.BALLOT_MEASURE, label: 'Ballot measures' }],
  },
  {
    label: 'Federal Candidates',
    options: [
      { value: TypeFilter.US_SENATE, label: 'US Senate' },
      { value: TypeFilter.US_HOUSE, label: 'US House' },
      { value: TypeFilter.US_OTHER, label: 'Other Federal' },
    ],
  },
  {
    label: 'State Candidates',
    options: [
      { value: TypeFilter.STATE_GOVERNOR, label: 'Governor' },
      { value: TypeFilter.STATE_OTHER_EXEC, label: 'Other Statewide Executive' },
      { value: TypeFilter.STATE_SUPREME_COURT_JUSTICE, label: 'State Supreme Court Justice' },
      { value: TypeFilter.STATE_LEGISLATOR, label: 'State Legislator' },
      { value: TypeFilter.STATE_OTHER, label: 'Other State' },
    ],
  },
  {
    label: 'Local Candidates',
    options: [{ value: TypeFilter.LOCAL_CANDIDATE, label: 'Local Candidates' }],
  },
];

export const PROCESSING_REDIRECT_OPTIONS = [
  { value: CartProcessingRedirect.DE_OATH, label: 'Democracy Engine' },
  { value: CartProcessingRedirect.STRIPE, label: 'Stripe' },
];
